module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/apple-touch-icon-152x1523622c550020c3e17bfdae3044a1e32fc.png";